import request from 'services/request'
import get from 'lodash/get'
import { createAuthorization } from '../../auth'

/*
 * Get user portal
 */
export async function getUserPortal ({ auth, server, uid }) {
  const res = await request
    .get(`${server}/v1/admin/user-portals/${uid}`)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
  return get(res, 'body', {})
}

/*
 * Get user portal by uuid
 */
export async function getUserPortalDataByUuid ({ auth, server, uuid }) {
  const res = await request
    .get(`${server}/v1/user-portals/user/${uuid}`)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
  return get(res, 'body', {})
}

/*
 * Get list of user portals
 */
export async function getUserPortals ({ auth, server, query }) {
  const res = await request
    .get(`${server}/v1/user-portals/search/${query}`)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
  return get(res, 'body', {})
}

/*
 * Create user portal
 */
export async function postUserPortal ({ auth, server, body }) {
  const res = await request
    .post(`${server}/v1/admin/user-portals`)
    .send(body)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
  return get(res, 'body', {})
}
/*
 * update User Portal
 */
export async function putUserPortal ({
  verifiedAuthentic,
  privacySetting,
  username,
  locked,
  server,
  tier,
  auth,
  uid,
  url,
  id,
}) {
  const res = await request
    .put(`${server}/v1/admin/user-portals/${id}`)
    .send({
      url, verifiedAuthentic, privacySetting, username, uid, locked, tier,
    })
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
  return get(res, 'body', {})
}
